import { CustomerType, Personality } from "src/app/@core/constants";

export class CustomerTableModel {

    code: string;
    fullName: string;
    personality: Personality;
    customerType: CustomerType;
    fiscalId: string;
    fiscalIdType: string;
    fiscalId2: string;
    useFiscalId2: boolean;
    codeAndFullName: string;
    age?: number;
    constructor() {
        this.code = "";
        this.fullName = "";
        this.personality = Personality.PERSON;
        this.customerType = CustomerType.RETAIL;
        this.fiscalId = "";
        this.fiscalIdType = "";
        this.fiscalId2 = "";
        this.useFiscalId2 = false;
        this.codeAndFullName = "";
    }
}
